import { SideNavItemsMap } from '../rankings/models/sideNavItemsMap';
import { SIDENAV_ITEMS_RISK_CATEGORIES } from './SIDENAV_ITEMS_RISK_CATEGORIES';

export const SIDENAV_ITEMSMAPS: Array<SideNavItemsMap> = [
  {
    id: 'risk-categories',
    title: 'Risk Categories',
    summaryMainFilterItems: [],
    sideNavItems: SIDENAV_ITEMS_RISK_CATEGORIES
  }
];
